import create from "zustand";

export type RootState = {
  language: string,
}

export const useStore = create<RootState>(() => ({
  language: 'de',
}))
